import { useQuery } from '@tanstack/react-query'
import { supabase } from '../api'

const getActivitiesCount = async (post_id, type) => {
  const { count, error } = await supabase
    .from('user_activities')
    .select('*', { count: 'exact', head: true })
    .eq('post_id', post_id)
    .eq('type', type)

  if (error) {
    throw new Error(error.message)
  }

  return count
}

export default function useActivitiesCount(post_id: string, type: string) {
  return useQuery({
    queryKey: ['useUserActivitiesCount', post_id, type],
    queryFn: () => getActivitiesCount(post_id, type),
    enabled: Boolean(post_id),
    staleTime: 0,
    cacheTime: 0,
    refetchOnMount: true,
  })
}
